module.exports = __webpack_public_path__ + "static/media/poster.03ea0064.png";